import type { PackagingOption } from '../../../graphql/query/getDelivery';

export const getId = ({
  moniker,
  type,
  packageType,
}: {
  moniker?: string | null;
  type: string;
  packageType?: string;
}) => `${type}.${moniker}.${packageType}`;

// snake_case format for MX-style keys
type DeliveryType =
  | 'mail'
  | 'printerless'
  | 'store'
  | 'ship_on_your_own'
  | 'none';

type DeliveryBreakdown = {
  id: string;
  name?: string | null;
  packagingOption?: PackagingOption;
  serviceType?: string | null;
};

export const getDeliveryType = ({
  id,
  packagingOption,
}: DeliveryBreakdown): DeliveryType => {
  const normalizedId = id.toLowerCase();
  if (
    normalizedId === 'ship_on_your_own' ||
    normalizedId.startsWith('ship_on_your_own')
  )
    return 'ship_on_your_own';
  if (normalizedId === 'return_in_store' || normalizedId.includes('in_store'))
    return 'store';
  if (packagingOption === 'PRINTERLESS') {
    return 'printerless';
  }
  if (packagingOption === 'NONE') {
    return 'none';
  }
  return 'mail';
};

export const getLabel = ({
  id,
  name,
  packagingOption,
  serviceType,
}: DeliveryBreakdown): string[] => {
  // TODO: These ids should be better formatted in graphql
  const deliveryType = getDeliveryType({ id, packagingOption });
  const normalizedId = id.toLowerCase();
  if (
    normalizedId === 'ship_on_your_own' ||
    normalizedId.startsWith('ship_on_your_own') ||
    normalizedId === 'return_in_store'
  ) {
    return [`pdx.delivery.type.${deliveryType}`];
  }
  if (packagingOption === 'PRINTERLESS' || name) {
    const baseDeliveryKeys = [
      `pdx.delivery.type.${deliveryType}.${name?.toLowerCase()}`,
      `pdx.delivery.type.${deliveryType}`,
    ];
    return serviceType
      ? [
          `pdx.delivery.type.${deliveryType}.${name?.toLowerCase()}.${serviceType.toLowerCase()}`,
          ...baseDeliveryKeys,
        ]
      : baseDeliveryKeys;
  }
  return [`pdx.delivery.type.${deliveryType}`];
};
